import { UmbModalToken } from '@umbraco-cms/backoffice/modal';

export const UMB_SEARCH_MODAL = new UmbModalToken('Umb.Modal.Search');
